import { render, staticRenderFns } from "./CampoDinamico.vue?vue&type=template&id=5de21398&scoped=true"
import script from "./CampoDinamico.vue?vue&type=script&lang=js"
export * from "./CampoDinamico.vue?vue&type=script&lang=js"
import style0 from "./CampoDinamico.vue?vue&type=style&index=0&id=5de21398&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5de21398",
  null
  
)

export default component.exports